import type { Schemas } from "#shopware";

export const useProductDetails = (product: Ref<Schemas["Product"]>) => {
  const { t } = useI18n();
  const groupedProperties = computed(() => {
    const properties = product?.value?.properties || [];
    const groups: {
      [key: string]: {
        group: Schemas["PropertyGroup"];
        properties: Schemas["PropertyGroupOption"][];
      };
    } = {};
    properties.forEach((property: Schemas["PropertyGroupOption"]) => {
      const groupId = property.group?.id;
      if (!groups[groupId]) {
        groups[groupId] = {
          group: property.group,
          properties: [],
        };
      }
      groups[groupId].properties.push(property);
    });
    return groups;
  });

  const measurements = computed(() => {
    return Object.entries({
      height: t("product.height"),
      width: t("product.width"),
      length: t("product.length"),
      weight: t("product.weight"),
    })
      .filter(
        ([key, label]) =>
          product.value?.[key] !== null && product.value?.[key] !== undefined
      )
      .map(([key, label]) => {
        const value = product.value?.[key];
        const unit = {
          height: "mm",
          width: "mm",
          length: "mm",
          weight: "kg",
        }[key];
        return {
          label,
          value: `${value} ${unit}`,
        };
      });
  });

  return {
    groupedProperties,
    measurements,
  };
};
